import { C as CreateNotification } from "./notification.js";
import { t as throttle, d as debounce } from "./lodash-utils.js";
import { p as pubsub } from "./shared-utilities.js";
import { S as SwiperInits } from "./swiper-slider.js";
import { s as stopScroll, r as resumeScroll } from "./scrollControl.js";
import { s as slideUp, a as slideDown } from "./slide.js";
import { d } from "./preact-core.js";
import { L as Loader } from "./google-maps-loader.js";
import "./layout-store.js";
class StickyNav {
  constructor() {
    this.sticky = false;
    this.navEl = document.querySelector(".global-header");
    this.handleSticky = throttle(this.handleSticky, 200, {
      leading: true
    }).bind(this);
    if (this.navEl !== void 0 || this.navEl !== null) {
      this.scrollPosition = window.scrollY;
      window.addEventListener("scroll", this.handleSticky);
      this.handleSticky();
    } else {
      console.warn("Sticky nav cant find nav");
    }
  }
  handleSticky() {
    this.scrollDirection = this.scrollPosition < window.scrollY ? "down" : "up";
    if (window.scrollY >= window.innerHeight && this.scrollDirection == "up" && !this.sticky && !this.animating) {
      this.setSticky();
    } else if (this.scrollDirection == "down" && !this.animating && this.sticky || window.scrollY <= window.innerHeight && this.sticky && !this.animating) {
      this.removeSticky();
    }
    this.scrollPosition = window.scrollY;
  }
  setSticky() {
    this.animating = true;
    this.sticky = true;
    this.navEl.classList.add("nav-sticky");
    setTimeout(() => {
      this.navEl.classList.add("nav-sticky--show");
      document.body.classList.add("nav-sticky--is-active");
    }, 200);
    setTimeout(() => {
      this.animating = false;
    }, 300);
  }
  removeSticky() {
    this.animating = true;
    this.sticky = false;
    this.navEl.classList.add("nav-sticky--hide");
    this.navEl.classList.remove("nav-sticky--show");
    document.body.classList.remove("nav-sticky--is-active");
    pubsub.emit("nav-unsticky");
    setTimeout(() => {
      this.navEl.classList.remove("nav-sticky--hide", "nav-sticky");
      this.animating = false;
    }, 200);
  }
}
const navTrigger = (() => {
  const ANIMATION_DURATION = 500;
  const STATE_CHANGE_DELAY = 200;
  const DEBOUNCE_DELAY = 200;
  let menuTriggers = null;
  let mainNav = null;
  let state = "closed";
  let isAnimating = false;
  const handleAnimation = () => {
    if (!mainNav) return;
    isAnimating = true;
    mainNav.classList.add("is-animating");
    setTimeout(() => {
      isAnimating = false;
      mainNav == null ? void 0 : mainNav.classList.remove("is-animating");
    }, ANIMATION_DURATION);
  };
  const bindElements = () => {
    mainNav = document.getElementById("main-nav");
    if (mainNav) {
      menuTriggers = document.querySelectorAll(".nav-trigger");
      if (menuTriggers.length === 0) {
        console.warn("No navigation triggers found");
      }
    } else {
      console.warn("Main navigation element not found");
    }
  };
  const updateTriggers = (expanded, active) => {
    if (!menuTriggers) return;
    menuTriggers.forEach((trigger) => {
      trigger.setAttribute("aria-expanded", expanded.toString());
      trigger.classList.toggle("--active", active);
    });
  };
  const handleClose = debounce(
    () => {
      if (state !== "open" || !mainNav) return;
      pubsub.emit("mainNavClose");
      handleAnimation();
      document.body.classList.remove("nav-is-open");
      mainNav.classList.remove("is-open");
      updateTriggers(false, false);
      resumeScroll();
      setTimeout(() => {
        state = "closed";
      }, STATE_CHANGE_DELAY);
    },
    DEBOUNCE_DELAY,
    { leading: true, trailing: false }
  );
  const handleOutsideClick = (event) => {
    const target = event.target;
    if (target == null ? void 0 : target.closest(".nav-trigger")) return;
    if (target == null ? void 0 : target.closest("#main-nav")) return;
    handleClose();
  };
  const handleOpen = () => {
    if (state !== "closed" || !mainNav) return;
    pubsub.emit("mainNavOpen");
    handleAnimation();
    document.body.classList.add("nav-is-open");
    mainNav.classList.add("is-open");
    updateTriggers(true, true);
    stopScroll();
    setTimeout(() => {
      state = "open";
      document.addEventListener("click", handleOutsideClick, { once: true });
    }, STATE_CHANGE_DELAY);
  };
  const toggleMenu = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (isAnimating) return;
    if (state === "closed") {
      handleOpen();
    } else if (state === "open") {
      handleClose();
    }
  };
  const init = () => {
    bindElements();
    if (!mainNav || !menuTriggers) {
      console.error(
        "Failed to initialize navigation trigger: required elements not found"
      );
      return;
    }
    menuTriggers.forEach((trigger) => {
      trigger.addEventListener("click", toggleMenu);
    });
  };
  return {
    init,
    close: handleClose,
    open: handleOpen,
    getState: () => state
  };
})();
function setLabelPositions(selector = ".form-group--styled input, .form-group--styled textarea", options) {
  const inputs = document.querySelectorAll(selector);
  const parentClass = ".form-group";
  const labelEvents = (input) => {
    const parent = input.closest(parentClass);
    input.addEventListener("focus", () => {
      if (parent != null) {
        parent.classList.add("active");
      }
    });
    input.addEventListener("blur-sm", () => {
      if (input.value === "" && parent != null) {
        parent.classList.remove("active");
      }
    });
    if (input.value !== "") {
      if (parent != null) {
        parent.classList.add("active");
      }
    }
  };
  inputs.forEach((input) => {
    labelEvents(input);
  });
}
const _MegaMenu = class _MegaMenu extends HTMLElement {
  /**
   * Constructor - Initializes the mega menu component
   */
  constructor() {
    super();
    this.externalTriggers = [];
    this.isOpen = false;
    this.usesTrigger = this.dataset.trigger !== void 0;
    this.mainNavEl = document.querySelector(".global-header");
    this.parentTriggers = this.getElementsByClassName(
      "mega-menu__parent-trigger"
    );
    this.dropdowns = this.getElementsByClassName(
      "mega-menu__sub-level"
    );
    this.backdropElement = this.querySelector(
      ".mega-menu__backdrop"
    );
    this.closeElement = this.querySelector(
      ".mega-menu__dropdown-close"
    );
    this.activeGroupName = d("");
    this.initializeExternalTriggers();
    this.initializeEvents();
  }
  /**
   * Initialize external triggers from the main navigation
   */
  initializeExternalTriggers() {
    if (this.usesTrigger) {
      const triggerKey = (this.dataset.trigger || "").trim().toLowerCase();
      this.mainNavEl.querySelectorAll("a, button").forEach((link) => {
        const linkEl = link;
        const linkText = (link.textContent || "").trim().toLowerCase();
        const linkDataTarget = (link.getAttribute && (link.getAttribute("data-target") || "")).toString().trim().toLowerCase();
        const href = (link.getAttribute && (link.getAttribute("href") || "")).toString().trim().toLowerCase();
        const matchesTrigger = !!triggerKey && (linkText === triggerKey || linkDataTarget === triggerKey || linkDataTarget === this.id.toLowerCase() || href === `#${triggerKey}` || href.endsWith(`#${this.id.toLowerCase()}`));
        if (matchesTrigger) {
          try {
            linkEl.setAttribute("data-mega-trigger", this.id);
            linkEl.classList.add("mega-external-trigger");
          } catch (err) {
          }
          this.externalTriggers.push({ el: linkEl, group: void 0 });
        }
      });
    }
    this.setupExternalTriggerEvents();
  }
  /**
   * Sets up event listeners for external trigger elements
   */
  setupExternalTriggerEvents() {
    this.externalTriggers.forEach((trigger) => {
      trigger.el.addEventListener("click", (e) => {
        if (window.innerWidth >= _MegaMenu.DESKTOP_BREAKPOINT) {
          e.preventDefault();
          trigger.el.classList.add("active");
          if (!this.isOpen) {
            this.openHamburger();
          }
        } else {
          trigger.el.classList.remove("active");
        }
      });
    });
  }
  /**
   * Handle parent trigger toggle events
   */
  handleParentTriggerToggle(e, trigger) {
    const hasChildren = trigger.dataset.target && this.querySelector(`#${trigger.dataset.target}`) !== null;
    if (!hasChildren && e.type === "click") {
      return;
    }
    e.preventDefault();
    const dropdown = this.querySelector(
      `#${trigger.dataset.target}`
    );
    Array.from(this.dropdowns).forEach((other_dropdown) => {
      if (other_dropdown !== dropdown && other_dropdown.classList.contains("active")) {
        slideUp(
          other_dropdown,
          {
            duration: 300
          },
          () => {
            other_dropdown.classList.remove("active");
          }
        );
      }
    });
    if (dropdown) {
      slideDown(
        dropdown,
        {
          duration: 300
        },
        () => {
          dropdown.classList.add("active");
        }
      );
    }
    this.dispatchEvent(
      new CustomEvent("setActiveParentGroup", {
        bubbles: true,
        composed: true,
        detail: trigger.dataset.target
      })
    );
  }
  /**
   * Initializes all event listeners for the mega menu
   */
  initializeEvents() {
    if (this.parentTriggers.length > 0) {
      this.activeGroupName.value = this.parentTriggers[0].dataset.target || "";
    }
    Array.from(this.parentTriggers).forEach((trigger) => {
      trigger.addEventListener("click", (e) => {
        this.handleParentTriggerToggle(e, trigger);
      });
    });
    this.addEventListener("setActiveParentGroup", (e) => {
      this.activeGroupName.value = e.detail;
      this.toggleActiveParentGroup();
    });
    this.backdropElement.addEventListener("click", () => this.closeHamburger());
    if (this.closeElement) {
      this.closeElement.addEventListener("click", () => this.closeHamburger());
    }
    window.addEventListener("scroll", () => this.closeHamburger());
    window.addEventListener("resize", () => {
      if (window.innerWidth < _MegaMenu.DESKTOP_BREAKPOINT) {
        if (this.isOpen) {
          this.closeHamburger();
        }
        this.externalTriggers.forEach((t) => t.el.classList.remove("active"));
      }
    });
    pubsub.on("megaMenuOpen", (data) => {
      if (data.id != this.id) {
        this.closeHamburger({
          siblingOpen: true
        });
      }
    });
  }
  /**
   * Opens the hamburger menu and prevents scrolling on mobile
   */
  openHamburger() {
    this.isOpen = true;
    this.classList.add("active");
    document.body.classList.add("mega-menu-active");
    document.body.classList.add(this.id);
    if (window.innerWidth < 998) {
      stopScroll();
    }
    pubsub.emit("megaMenuOpen", {
      id: this.id
    });
  }
  /**
   * Closes the hamburger menu and resumes scrolling
   */
  closeHamburger(options) {
    this.isOpen = false;
    this.classList.remove("active");
    this.externalTriggers.forEach((trigger) => {
      trigger.el.classList.remove("active");
    });
    if ((options == null ? void 0 : options.siblingOpen) === true) {
      return;
    }
    document.body.classList.remove("mega-menu-active");
    document.body.classList.remove(this.id);
    resumeScroll();
  }
  /**
   * Toggles the active parent group in the mega menu
   */
  toggleActiveParentGroup() {
    console.log("Toggling active parent group:", this.activeGroupName.value);
    Array.from(this.parentTriggers).forEach((trigger) => {
      const parentNode = trigger.parentNode;
      if (trigger.dataset.target === this.activeGroupName.value) {
        parentNode.classList.add("active");
      } else {
        parentNode.classList.remove("active");
      }
    });
  }
  simplifyActiveName(str) {
    return str.replace("-dropdown", "").replace("-menu", "");
  }
};
_MegaMenu.DESKTOP_BREAKPOINT = 1200;
let MegaMenu = _MegaMenu;
const _MainNavDropdowns = class _MainNavDropdowns {
  constructor() {
    this.eventListeners = /* @__PURE__ */ new Map();
    this.links = document.querySelectorAll(".nav__dropdown-toggle");
    this.init();
    this.handleResize();
  }
  /**
   * Initialize dropdown functionality
   */
  init() {
    this.links.forEach((item) => {
      _MainNavDropdowns.bindEvents(item);
    });
  }
  /**
   * Handle window resize events to close dropdowns when switching between desktop/mobile
   */
  handleResize() {
    let resizeTimer;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        this.links.forEach((item) => {
          const targetSelector = item.getAttribute("data-target");
          if (targetSelector) {
            const target = document.querySelector(
              targetSelector
            );
            if (target && item.getAttribute("aria-expanded") === "true") {
              _MainNavDropdowns.closeDropdown(target, item);
            }
          }
        });
      }, 150);
    });
  }
  /**
   * Closes a dropdown menu
   * @param target - The dropdown element to close
   * @param item - The toggle element that triggers the dropdown
   */
  static closeDropdown(target, item) {
    if (!target || !item) return;
    item.setAttribute("aria-expanded", "false");
    target.classList.remove("open");
    if (window.innerWidth <= _MainNavDropdowns.MOBILE_BREAKPOINT) {
      slideUp(target);
    }
    let mainNav = document.getElementById("main-nav");
    if (mainNav) {
      mainNav.classList.remove("--dropdown-open");
    }
  }
  /**
   * Opens a dropdown menu on desktop devices
   * @param target - The dropdown element to open
   * @param item - The toggle element that triggers the dropdown
   */
  static openDropdown(target, item) {
    if (!target || !item) return;
    const isMegaTrigger = item instanceof HTMLElement && (item.getAttribute && item.getAttribute("data-mega-trigger") || item.classList.contains("mega-external-trigger"));
    if (window.innerWidth >= _MainNavDropdowns.DESKTOP_BREAKPOINT) {
      if (isMegaTrigger) return;
      if (item.getAttribute("aria-expanded") === "false") {
        item.setAttribute("aria-expanded", "true");
        const header = document.querySelector("header");
        if (header) {
          header.addEventListener(
            "mouseleave",
            () => {
              _MainNavDropdowns.closeDropdown(target, item);
            },
            { once: true }
          );
        }
        target.classList.add("open");
        let mainNav = document.getElementById("main-nav");
        if (mainNav) {
          mainNav.classList.add("--dropdown-open");
        }
      }
      target.querySelectorAll(".dropdown__link").forEach((link) => {
        link.addEventListener("mouseenter", () => {
          _MainNavDropdowns.handleHover(link);
        });
        link.addEventListener("mouseleave", () => {
          _MainNavDropdowns.handleMouseOut(link);
        });
      });
    }
  }
  /**
   * Opens a dropdown menu on mobile devices
   * @param target - The dropdown element to open
   * @param item - The toggle element that triggers the dropdown
   */
  static openMobile(target, item) {
    if (!target || !item) return;
    if (item.getAttribute("aria-expanded") === "false") {
      item.setAttribute("aria-expanded", "true");
      if (window.innerWidth <= _MainNavDropdowns.MOBILE_BREAKPOINT) {
        target.classList.add("open");
        slideDown(target);
      }
      if (item.parentNode) {
        item.parentNode.classList.add("--dropdown-open");
      }
      document.addEventListener(
        "click",
        () => {
          _MainNavDropdowns.closeDropdown(target, item);
        },
        { once: true }
      );
    }
  }
  /**
   * Handles hover effect on dropdown links
   * @param link - The link element being hovered
   */
  static handleHover(link) {
    const target = link.getAttribute("data-link");
    if (!target) return;
    const message = document.getElementById(target);
    if (message) {
      message.classList.remove("opacity-0");
      message.classList.add("opacity-100");
    }
  }
  /**
   * Handles mouse out effect on dropdown links
   * @param link - The link element being left
   */
  static handleMouseOut(link) {
    const target = link.getAttribute("data-link");
    if (!target) return;
    const message = document.getElementById(target);
    if (message) {
      message.classList.add("opacity-0");
      message.classList.remove("opacity-100");
    }
  }
  /**
   * Binds event listeners to dropdown toggle elements
   * @param item - The dropdown toggle element
   */
  static bindEvents(item) {
    const targetSelector = item.getAttribute("data-target");
    if (!targetSelector) return;
    const target = document.querySelector(targetSelector);
    if (!target) return;
    item.addEventListener("mouseenter", () => {
      _MainNavDropdowns.openDropdown(target, item);
    });
    item.addEventListener("click", (event) => {
      if (window.innerWidth >= _MainNavDropdowns.DESKTOP_BREAKPOINT) {
        return;
      } else {
        const isExpanded = item.getAttribute("aria-expanded") === "true";
        event.preventDefault();
        event.stopPropagation();
        if (!isExpanded) {
          _MainNavDropdowns.openMobile(target, item);
        } else {
          _MainNavDropdowns.closeDropdown(target, item);
        }
      }
    });
    item.addEventListener("keydown", (event) => {
      const keyboardEvent = event;
      if (keyboardEvent.key === "Enter" || keyboardEvent.key === " ") {
        event.preventDefault();
        event.stopPropagation();
        const isExpanded = item.getAttribute("aria-expanded") === "true";
        if (isExpanded) {
          _MainNavDropdowns.closeDropdown(target, item);
        } else {
          if (window.innerWidth >= _MainNavDropdowns.DESKTOP_BREAKPOINT) {
            _MainNavDropdowns.openDropdown(target, item);
          }
        }
      }
      if (keyboardEvent.key === "Escape") {
        _MainNavDropdowns.closeDropdown(target, item);
      }
    });
  }
  /**
   * Clean up event listeners when component is destroyed
   * Call this method when the component is no longer needed to prevent memory leaks
   */
  destroy() {
    this.eventListeners.forEach((controller, element) => {
      controller.abort();
    });
    this.eventListeners.clear();
  }
};
_MainNavDropdowns.DESKTOP_BREAKPOINT = 1200;
_MainNavDropdowns.MOBILE_BREAKPOINT = 1199;
let MainNavDropdowns = _MainNavDropdowns;
const mapStyles = [
  {
    elementType: "geometry",
    stylers: [
      {
        color: "#f5f5f5"
      }
    ]
  },
  {
    elementType: "labels.icon",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#616161"
      }
    ]
  },
  {
    elementType: "labels.text.stroke",
    stylers: [
      {
        color: "#f5f5f5"
      }
    ]
  },
  {
    featureType: "administrative.land_parcel",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#bdbdbd"
      }
    ]
  },
  {
    featureType: "poi",
    elementType: "geometry",
    stylers: [
      {
        color: "#eeeeee"
      }
    ]
  },
  {
    featureType: "poi",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#757575"
      }
    ]
  },
  {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [
      {
        color: "#e5e5e5"
      }
    ]
  },
  {
    featureType: "poi.park",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#9e9e9e"
      }
    ]
  },
  {
    featureType: "road",
    elementType: "geometry",
    stylers: [
      {
        color: "#ffffff"
      }
    ]
  },
  {
    featureType: "road.arterial",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#757575"
      }
    ]
  },
  {
    featureType: "road.highway",
    elementType: "geometry",
    stylers: [
      {
        color: "#dadada"
      }
    ]
  },
  {
    featureType: "road.highway",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#616161"
      }
    ]
  },
  {
    featureType: "road.local",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#9e9e9e"
      }
    ]
  },
  {
    featureType: "transit.line",
    elementType: "geometry",
    stylers: [
      {
        color: "#e5e5e5"
      }
    ]
  },
  {
    featureType: "transit.station",
    elementType: "geometry",
    stylers: [
      {
        color: "#eeeeee"
      }
    ]
  },
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [
      {
        color: "#c9c9c9"
      }
    ]
  },
  {
    featureType: "water",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#9e9e9e"
      }
    ]
  }
];
const loader = new Loader({
  apiKey: window.googleMapsApiKey,
  version: "weekly",
  libraries: ["places", "marker"]
});
function isInfoWindowOpen(infowindow) {
  const map = infowindow.getMap();
  return map !== null && typeof map !== "undefined";
}
const MapWithMarker = (mapId) => {
  const contactMap = document.getElementById(mapId);
  console.log("MapWithMarker initialized", contactMap, mapId);
  if (contactMap) {
    loader.load().then(async () => {
      const { Map: Map2 } = await google.maps.importLibrary(
        "maps"
      );
      const mapLat = Number(contactMap.getAttribute("data-lat"));
      const mapLng = Number(contactMap.getAttribute("data-lng"));
      const mapZoom = Number(contactMap.getAttribute("data-zoom"));
      const mapPoints = contactMap.getAttribute("data-points").replace(",]", "]");
      const googleMapEl = new Map2(contactMap, {
        center: { lat: mapLat, lng: mapLng },
        zoom: mapZoom,
        disableDefaultUI: true,
        draggable: true,
        scrollwheel: true,
        panControl: true,
        styles: mapStyles
      });
      const svgActive = {
        path: "M 25, 50, a 25,25 0 1,1 50,0, a 25,25 0 1,1 -50,0",
        fillColor: "#ffffff",
        fillOpacity: 1,
        strokeWeight: 1,
        strokeColor: "#4E6152",
        rotation: 0,
        scale: 0.5,
        anchor: new google.maps.Point(60, 30)
      };
      const svgMarker = {
        path: "M 25, 50, a 25,25 0 1,1 50,0, a 25,25 0 1,1 -50,0",
        fillColor: "#4E6152",
        fillOpacity: 1,
        strokeWeight: 1,
        strokeColor: "#4E6152",
        rotation: 0,
        scale: 0.5,
        anchor: new google.maps.Point(60, 30)
      };
      const points = JSON.parse(mapPoints);
      points.forEach((point) => {
        const marker = new google.maps.Marker({
          position: { lat: Number(point.lat), lng: Number(point.lng) },
          map: googleMapEl,
          icon: svgMarker
        });
        if (point.title && point.address) {
          const contentString = `
          <div class="cluster-info">
            <p>${point.title}</p>
            <p>${point.address}</p>
          </div>
          `;
          const infowindow = new google.maps.InfoWindow({
            content: contentString
          });
          google.maps.event.addListener(marker, "mouseout", () => {
            infowindow.close(googleMapEl, marker);
            marker.setIcon(svgMarker);
          });
          marker.addListener("click", () => {
            if (isInfoWindowOpen(infowindow)) {
              infowindow.close(googleMapEl, marker);
              marker.setIcon(svgMarker);
            } else {
              infowindow.open(googleMapEl, marker);
              marker.setIcon(svgActive);
            }
          });
        }
      });
    });
  }
};
navTrigger.init();
SwiperInits();
setLabelPositions();
new StickyNav();
new CreateNotification("header-notification", "bar");
new CreateNotification("small-notification", "fade", 100);
new CreateNotification("large-newsletter-signup", "fade", 100);
new CreateNotification("age-gate", "fade");
new MainNavDropdowns();
customElements.define("mega-menu", MegaMenu);
if (document.getElementById("map-section")) {
  MapWithMarker("map-section");
}
